import React, { Component } from 'react';
import { reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import publishPageHeight from '../../publishPageHeight';
import RippleButton from '../Forms/RippleButton';
import { sendEvent } from '../../utils/eventUtils';

/* eslint-disable */
const normalize = (value) => {
  if (!value) return value;

  const cleanValue = parseFloat(value.toString().replace(/\./g, '').replace(/,/g, ''));
  return (cleanValue / 100).toFixed(2);
}

const convertAmountToNumber = (amount) => {
  return Number(normalize(amount)).toFixed(2);
}

class WireTransferDepositTSEUFutures extends Component {

  componentDidMount() {
    sendEvent({
      version: '1.0',
      eventType: 'COMPONENT_MOUNTED',
      context: "WIRE_DEPOSIT_VIEW_INSTRUCTIONS_TSEU_FUTURES",
    });
  }

  componentDidUpdate() {
    publishPageHeight();
  }

  render() {
    const { handleSubmit } = this.props;
    const values = this.props.formValues.values;
    const forFurtherCredit = <dl>
      <dt>Further Credit To:</dt>
      <dd>{values.fundsDestinationAccount.accountTitle}</dd>
      <dt>Account Number:</dt>
      <dd>{values.fundsDestinationAccount.accountNumber}</dd>
      <dt>By Order Of:</dt>
      <dd>&#60;Account Title at Sending Bank&#62;</dd>
      <dt />
      <dd className="description">
        The title of your Stichting TradeStation Europe account and the title&nbsp;
        of the account from which you are transferring funds must match.</dd>
    </dl>;

    const instructions = {
      EUR: {
        'Beneficiary Bank': <dl>
          <dt>Beneficiary Bank:</dt>
          <dd>J.P. Morgan SE - Amsterdam Branch</dd>
          <dt>Address:</dt>
          <dd>WTC Tower B, Strawinskylaan 1135,<br />
            1077 XX Amsterdam, The Netherlands</dd>
          <dt>SWIFT BIC Routing:</dt>
          <dd>CHASNL2X</dd>
        </dl>,
        'Beneficiary Account': <dl>
          <dt>Beneficiary Account:</dt>
          <dd>Stichting TradeStation Europe</dd>
          <dt>Address:</dt>
          <dd>Apollolaan 151<br />
            Amsterdam 1077AR - The Netherlands</dd>
          <dt>Account Title:</dt>
          <dd>Stichting TradeStation Europe</dd>
          <dt>Account Number:</dt>
          <dd>0626005999 (IBAN is preferred)</dd>
          <dt>IBAN:</dt>
          <dd>NL74CHAS0626005999</dd>
        </dl>,
      },
      USD: {
        'Beneficiary Bank': <dl>
          <dt>Beneficiary Bank:</dt>
          <dd>J.P. Morgan SE - Amsterdam Branch</dd>
          <dt>Address:</dt>
          <dd>WTC Tower B, Strawinskylaan 1135,<br />
            1077 XX Amsterdam, The Netherlands</dd>
          <dt>SWIFT BIC Routing:</dt>
          <dd>CHASNL2X</dd>
        </dl>,
        'Beneficiary Account': <dl>
          <dt>Beneficiary Account:</dt>
          <dd>Stichting TradeStation Europe</dd>
          <dt>Address:</dt>
          <dd>Apollolaan 151<br />
            Amsterdam 1077AR - The Netherlands</dd>
          <dt>Account Title:</dt>
          <dd>Stichting TradeStation Europe</dd>
          <dt>Account Number:</dt>
          <dd>0626006000 (IBAN is preferred)</dd>
          <dt>IBAN:</dt>
          <dd>NL47CHAS0626006000</dd>
        </dl>,
      },
    };

    return (
      <form className="confirmation" onSubmit={handleSubmit}>
        <section id="wire-deposit-futures">
          <h4>Instructions for TradeStation Europe</h4>
          <p>Provide the instructions below to your bank or brokerage firm.</p>
          <h4>Important Notes</h4>
          <p>Transferred funds will be available the next business day if the request is received between 15:00 and 22:00 CET and includes all required information.</p>
          <p>Please do not wire funds until your account is approved, and you have confirmed the account is ready to receive a wire.</p>
          <p>The sending bank/firm must reference the title of your account from which the funds originated.</p>
          <p><b>Foreign currency funds will automatically be converted to USD upon receipt. This will create a currency rate risk exposure should you need to convert the funds back to a non-USD currency, which could result in noticeable profit/loss.</b></p>
          <dl>
            <dt id="deposit-amount">Deposit Amount:&nbsp;
              <span className="amount">{`${(this.props.formValues.values.transferAmount || 0).toLocaleString(
                'en-US', { style: 'currency', currency: this.props.formValues.values.transferCurrency }
              )} ${this.props.formValues.values.transferCurrency}`}</span></dt>
          </dl>
          <div className="instruction-block">
            {Object.keys(instructions[values.transferCurrency]).map(descriptionKey =>
              <div key={descriptionKey}>
                <h5>{descriptionKey}</h5>
                {instructions[values.transferCurrency][descriptionKey]}
              </div>
            )}
            <h5>For Further Credit Instructions</h5>
            {forFurtherCredit}
          </div>
          <div className="actions">
            <RippleButton className="default" context="EDIT_WIRE_DEPOSIT_FORM">edit</RippleButton>
            {this.props.showPrintButton &&
              <RippleButton className="primary" onClick={(e) => this.props.printPage(e)}>print</RippleButton>}
          </div>
        </section>
      </form>
    );
  }
}

WireTransferDepositTSEUFutures.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  printPage: PropTypes.func.isRequired,
  showPrintButton: PropTypes.bool.isRequired,
  formValues: PropTypes.shape({
    values: PropTypes.shape(),
  }),
};

export default reduxForm({
  form: 'wireTransferDepositForm',
  destroyOnUnmount: false,
})(WireTransferDepositTSEUFutures);
